<template>
  <Layout>
    <div class="row">
      <div class="col-md-12"  v-if="Object.keys(trainee_batch).length !== 0">
        <b-card>
          <div class="text-center clear" style="margin-top: -18px;">
            <span style="font-size: 18px">Attendance Report of {{ trainee_name }}</span><br />
            Batch No: {{ trainee_batch.batch_no }}<br />
            Training Trade: {{ trainee_batch.trade.desc }}<br />
            Total Present: {{ present_attendance }} | Total Absent: {{ absent_attendance }}<br />
          </div>
        </b-card>
        <b-card>
          <div class="row">
            <div class="col-md-12 mb-2">
              <div v-if="flag">
                <span class="badge badge-success">Total Search Data Found: {{ trainee_attendances.length }}</span>
              </div>
            </div>
          </div>
          <table class="table table-centered table-striped">
            <thead>
            <tr>
              <th>Day</th>
              <th>Attendance</th>
              <th>Remarks</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(trainee_attendance, index) in trainee_attendances" :key="index">
              <td>{{ customAttendanceDate(trainee_attendance.attendance_date) }}</td>
              <td>
                <span :class="trainee_attendance.class">{{ trainee_attendance.attendance }}</span>
              </td>
              <td>{{ trainee_attendance.remark }}</td>
            </tr>
            </tbody>
          </table>
        </b-card>
      </div>
      <div class="col-md-12" v-if="Object.keys(trainee_batch).length === 0 && !flag">
        <h5 style="text-align: center">No Data Found</h5>
      </div>
    </div>
  </Layout>
</template>

<script>
import Datepicker from "vuejs-datepicker";

import appConfig from "@src/app.config";
import Layout from "@layouts/profile-layout";
import PageHeader from "@components/page-header";
import http from "@state/http";
import moment from "moment";

export default {
  page: {
    title: "List of Attendance ",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, Datepicker },
  data() {
    return {
      title: "List of Attendance",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Attendance",
          active: true
        }
      ],

      trainee_attendances: [],
      present_attendance: '',
      absent_attendance: '',
      trainee_name: "",
      trainee_id: "",
      trainee_batch: {},
      flag: false,
    };
  },

  mounted() {
    this.trainee_id = this.$route.params.trainee_id;
    this.getTraineeAttendance(this.trainee_id);
    this.getTraineeName(this.trainee_id);
    this.getTraineeBatch(this.trainee_id);
  },
  methods: {
    getTraineeAttendance(trainee_id) {
      http.get("api/getTraineeAttendance/" + trainee_id).then(response => {
        this.trainee_attendances = response.data.trainee_attendances;
        this.present_attendance = response.data.present_attendance;
        this.absent_attendance = response.data.absent_attendance;
      });
    },
    getTraineeName(trainee_id) {
      http.get("api/getTraineeName/" + trainee_id).then(response => {
        this.flag = true;
        this.trainee_name = response.data.trainee_name;
      });
    },
    getTraineeBatch(trainee_id) {
      http.get("api/getTraineeBatch/" + trainee_id).then(response => {
        this.flag = true;
        this.trainee_batch = response.data.trainee_batch;
      });
    },
    customAttendanceDate(date) {
      return moment(date).format("LL");
    },
  },
};
</script>
